module.exports = __webpack_public_path__ + "static/weJay3-363891838301a4248c6074fa7f40946e.png";